import React, { Component } from 'react';
import { connect } from 'react-redux';
import withBackend from '../../backend/withBackend';
import { compose } from 'redux';
import { setUser } from '../../actions';
import Home from '../../components/Home';
import XPage from '../../components/XPage';

class XContainer extends Component {
  render() {
    const { setUser, firebase } = this.props;
    return <XPage  firebase={firebase} setUser={setUser} />;
  }
}

export default compose(
  connect(null, { setUser }),
  withBackend
)(XContainer);